// extracted by mini-css-extract-plugin
export var carrierIcon = "_um-0";
export var carrierLogo = "_um-1";
export var detailsSection = "_um-2";